export default {
  cropResource: {
    crop: '裁切',
    clip: '剪辑',
    cropMsg: '裁剪失败',
  },
  groupSetting: {
    removeGroup: '解除编组',
  },
  disabledStyleTips:
    '当前图层存在%{animationName}动画，可在动画面板修改初始状态的%{animationName}',
  basicStyle2: {
    title: '位置尺寸',
    rotationAngle: '旋转角度',
    Opacity: '不透明度',
    scaleX: '缩放X',
    scaleY: '缩放Y',
    anchoredX: '坐标X',
    anchoredY: '坐标Y',
    defaultAnimation: '龙骨动作',
    sequenceFrame: '序列帧',
    visible: '可见',
    scaleTitle: '缩放比例',
    scaleXText: '水平缩放',
    scaleYText: '垂直缩放',
    pivotTitle: '锚点',
    pivotXText: '锚点 X',
    pivotYText: '锚点 Y',
    pivotDesc: '绿点为锚点<br/>可移动绿点调整锚点位置',
  },
  screenAdapter: {
    title: '屏幕适配方式',
  },
  align: {
    left: '左对齐',
    horizontalCenter: '水平居中',
    right: '右对齐',
    top: '顶对齐',
    verticalCenter: '垂直居中',
    bottom: '底对齐',
    horizontalSpacing: '水平分散对齐',
    verticalSpacing: '垂直分散对齐',
  },
  nine: {
    title: '点九图',
    left: '左',
    right: '右',
    top: '上',
    bottom: '下',
  },
  reuseLayout: {
    horizontalText: '复用竖屏位置尺寸配置',
    verticalText: '复用横屏位置尺寸配置',
  },
  resetSize: {
    title: '重置大小',
  },
  dragonBoneSetting: {
    title: '动画选择',
    animationName: '动画选择',
    playOnAwake: '入场自动播放',
    playSetting: '播放设置',
    playLoop: '无限循环',
    playSpeed: '播放速度',
    startPlay: '开始播放',
    pausePlay: '暂停播放',
  },
  screenSplitProp: {
    visibleContent: '[显示隐藏参数]横竖屏拆分',
    visibleTips: '横屏和竖屏下，当前图层的显示隐藏可分别设置为不同值',
    layoutContent: '[位置及尺寸]参数横竖屏拆分',
    layoutTips:
      '在横屏和竖屏下，当前图层的位置和尺寸可分别设置，系统默认拆分，不可更改',
    adaptationContent: '[屏幕适配方式]参数横竖屏拆分',
    adaptationTips: '在横屏和竖屏下，当前图层的屏幕适配方式可分别设置',
    scaleContent: '[缩放比例]参数横竖屏拆分',
    scaleTips: '横屏和竖屏下，当前图层的缩放比例可分别设置为不同值',
    pivotContent: '[锚点]参数横竖屏拆分',
    pivotTips: '横屏和竖屏下，当前图层的锚点可分别设置为不同值',
    fontSizeContent: '[文本字号]参数横竖屏拆分',
    fontSizeTips: '横屏和竖屏下，当前文本的字号可分别设置为不同值',
    dragonBoneContent: '[部分龙骨参数]横竖屏拆分',
    dragonBoneTips:
      '横屏和竖屏下，当前图层的部分龙骨参数可分别设置为不同值，包括动画选择 / 无限循环 / 播放速度',
    tweenPositionContent: '[位移距离]参数横竖屏拆分',
    tweenPositionTips: '横屏和竖屏下，当前位移动画的位移距离可分别设置为不同值',
    tweenScaleContent: '[缩放比例]参数横竖屏拆分',
    tweenScaleTips: '横屏和竖屏下，当前缩放动画的缩放比例可分别设置为不同值',
    rotationContent: '[旋转角度]参数横竖屏拆分',
    rotationTips: '横屏和竖屏下，当前图层的旋转角度可分别设置为不同值',
  },
  ratioLock: '固定比例',
}
